<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div>
        <v-img
          alt="Mainova Logo"
          contain
          :src="require('@/assets/logo.png')"
          width="130"
        />
      </div>

      <v-spacer></v-spacer>

      <div class="pt-5 pr-5">
        <v-switch
          v-model="group"
          label="Sensoren gruppieren"
        ></v-switch>
      </div>
    </v-app-bar>

    <v-main v-show="ready">
      <router-view></router-view>
    </v-main>

    <v-dialog
      :value="!ready"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Bitte warten
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  data() {
    return {
      loggingout: false,
      group: true
    };
  },
  async created() {
    if (this.$route.params.token) {
      this.$store.commit('setToken', this.$route.params.token);

      await this.$store.dispatch('login');

      if (this.loggedin) {
        this.$router.replace({ name: 'Home' });

        this.$store.commit('ready');
      } else {
        this.$router.replace({ name: 'Login' });

        this.$store.commit('ready');
      }

      return;
    }

    if (!this.loggedin && this.token) {
      await this.$store.dispatch('login');

      if (this.loggedin) {
        if (this.$route.path !== this.initialLink) {
          this.$router.replace(this.initialLink);
        }
      } else {
        this.$store.commit('setLoginPage', this.$route.path);
        if (this.$route.name !== 'Login') {
          this.$router.replace({ name: 'Login' });
        }
      }

      this.$store.commit('ready');
    } else if (!this.loggedin && !this.token) {
      this.$store.commit('setLoginPage', this.$route.path);
      if (this.$route.name !== 'Login') {
        this.$router.replace({ name: 'Login' });
      }

      this.$store.commit('ready');
    }
  },
  watch: {
    group(val) {
      this.$store.commit('groupBy', val);
    }
  },
  computed: {
    ...mapGetters(['loggedin', 'loggingin', 'token', 'ready', 'initialLink'])
  }
};
</script>

<style lang="scss">
html, body {
  overflow: hidden !important;
}
</style>
